import {
    convertUniversalDateToPersianDateFullInfo,
    RaikoBaseCardContainer, RaikoButtonSecondary,
    RaikoGridOneColumn,
    RaikoLabel,
    RaikoLabelType
} from "@moeindal/base-raiko-panel-components";
import {Skeleton} from "@mui/material";
import * as React from "react";
import "./DashboardReportCard.scss"
import {useNavigate} from "react-router-dom";
import {css} from "@emotion/css";

export default function DashboardReportCard(
    {
        mainTitle = "",
        loading,
        id = "",
        title,
        startDate = "",
        endDate = "",
        globalUrl,
        icon="ic_residence",
        background="backgroundColorEmerald100"
    }) {

    const navigate = useNavigate()

    return (
        <>
            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoLabel text={mainTitle} raikoLabelType={RaikoLabelType.TITLE}/>
                    {
                        loading ?
                            <Skeleton
                                variant="rectangular"
                                className={css`
                                    min-height: 74px;
                                    min-width: 120px;`}
                            /> : <div className={"dashboardReportCardLayout"}>
                                <div className={`${"dashboardReportCardIconContainer"} ${background}`}>
                                    <div className={icon}/>
                                </div>
                                <div className={"dashboardReportCardContainer"}>
                                    <p className={"dashboardReportCardItemTitle"}>
                                        {title}
                                    </p>
                                    <span className={"dashboardReportCardItemSubtitle"}>
                                         {`${convertUniversalDateToPersianDateFullInfo(startDate)} الـــــــی ${convertUniversalDateToPersianDateFullInfo(endDate)}`}
                                    </span>
                                </div>
                                <RaikoButtonSecondary label={"مشاهده بیشتر"} onClick={_ => {
                                    navigate(globalUrl.replace(":id", id),
                                        {state: {title: title}, replace: false})
                                }}/>

                            </div>
                    }
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>

        </>
    )
}